import {
  ExtractFetchParams,
  ExtractResponse,
  ExtractSuspenseQueryOptions,
  useSuspenseRequest,
} from "@/lib/openapi/hooks";

export type UseBllsTransactionsResponse = ExtractResponse<
  "serviceBilling",
  "/transactions",
  "get"
>;

export type UseBllsTransactionsFetchParams = ExtractFetchParams<
  "serviceBilling",
  "/transactions",
  "get"
>;

export const useBllsTransactionsQuery = <
  Response extends UseBllsTransactionsResponse,
  Transformed = Response
>(
  {
    queryOptions,
    fetchParams,
  }: {
    queryOptions?: ExtractSuspenseQueryOptions<Response, Transformed>;
    fetchParams?: UseBllsTransactionsFetchParams;
  } = { queryOptions: { errorResult: [] as unknown as Response } }
) =>
  useSuspenseRequest("serviceBilling", "/transactions", {
    method: "get",
    queryOptions,
    fetchParams,
  });
